/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_ENTRY_LIST (state, val) {
    state.entryList = val
  },
  UPDATE_ENTRY_LIST (state, val) {
    state.entryList.push(...val)
  },
  SET_ENTRY_COMMENTS(state, val) {
    state.entryComments = val
  },
  ADD_ENTRY_COMMENT (state, val) {
    state.entryComments.unshift(val)
  },
}
